// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/pic12.jpg"
import img2 from "../Assets/pic13.jpg"
import img3 from "../Assets/bone1.jpg"
import img4 from "../Assets/bone2.jpg"
import img5 from "../Assets/bone3.jpg"




function Bone() {


    return (
        <div className="min-h-screen bg-white">


            <div className="flex flex-col items-center  min-h-screen p-4 w-full font-serif">
                <p className="text-3xl text-gray-700 mb-2">
                    Finite Element Analysis: A new clinical tool to assess bone Quality

                </p>

                <p className="text-1xl mb-2">
                    We are working on to measure bone quality of osteoporosis patient. Osteoporosis diseases is now a days second most important health care problem, ranked by World Health Organization. By using Finite Element Tool, we are measuring bone quality. In this study we are simulating the bone behavior at different type of physiological loading condition. This study will be used to doctor for early prediction of osteoporosis induced fracture and effect of different medication on bone strength with time. This research is conducted in collaboration with group and expert of Post Graduate Institute of Medical Education and Research Chandigarh.
                </p>


                <div className="w-full h-1 border border-black"></div>

                <img
                    src={img1}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4"
                />

                <div className="w-full h-1 border border-black"></div>


                <img
                    src={img2}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4" />


                <div className="w-full h-1 border border-black"></div>

                <p className="text-3xl text-gray-700 mb-2 mt-4">
                    Investigation of Mechanical, Material, and Compositional Determinants of Human Trabecular Bone Quality in Type 2 Diabetes
                </p>


                <p className="text-1xl mb-2">
                    This study finding provides evidence that diabetes affects the trabecular bone quality at multiple organization levels. The accumulation of AGEs is 1 of the processes that favor deterioration of bone quality in diabetes leading to material, structural, compositional, and bio mechanical dysfunctional. Overall, together with altered structure and material properties, these novel findings of changes in the composition of bone explain the compromised mechanical performance and diminished bone strength in diabetes. Finally, this study demonstrates that whilst osteoporotic bones are fracture prone, diabetes is detrimental to bone quality, thus highlighting the need for more specific measures to understand and diagnose bone quality and bone fragility in T2D.
                </p>

                <img
                    src={img3}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4" />


                <div className="w-full h-1 border border-black"></div>

                <p className="text-3xl text-gray-700 mb-2 mt-4">
                    Effect of organic matrix alteration on strain rate dependent mechanical behavior of cortical bone
                </p>


                <p className="text-1xl mb-2">
                    This study shed light on the effect of organic matrix alteration on strain rate-dependent mechanical response of cortical bone. The thermal treatment induced denaturation of collagen in bone causes a significant reduction in macro and micro-scale mechanical properties. The strain rate sensitivity of bone reduces at high strain rates as denaturation of collagen increases. Furthermore, FTIR results provide insight into the secondary structure of collagen and its influence on the mechanical properties of bone. The results of present study can be helpful in understanding the bone disorders associated with the alteration in organic phase and further development of therapeutic interventions.
                </p>

                <img
                    src={img4}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4" />

                <div className="w-full h-1 border border-black"></div>

                <p className="text-3xl text-gray-700 mb-2 mt-4">
                Anatomical variation in intracortical canal network microarchitecture and its influence on bone fracture risk
                                </p>


                <p className="text-1xl mb-2">
                In the present study, site-dependent variation in the microstructural parameters of vascular canal porosity of rat tibia bone was investigated, and further its effect on bone fracture risk was assessed. Micro-CT derived vascular canal parameters were found heterogeneously distributed across the cortex. Vascular canal porosity was found significantly higher in the lateral cortex compared to the posterior cortex whereas canal diameter and canal numbers density were found site-independent. Further, the micro-FE results show that bone fracture risk strongly associated with the orientation of canals and vascular canal porosity. In conclusion, the findings of this study shed light on the importance of vascular canal network microarchitecture on bone fracture risk. These findings can be helpful in the non-invasive assessment of the bone fracture risk in pre-clinical studies.
                </p>

                <img
                    src={img5}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4" />


            </div>




        </div>
    );
}

export default Bone;
